module.exports = __webpack_public_path__ + "static/media/ipadair_light.7264d34b.svg";